// Reveals the full-color hero image inside a soft circle that follows the cursor.
if (!customElements.get('haya-spotlight')) {
  customElements.define(
    'haya-spotlight',
    class HayaSpotlight extends HTMLElement {
      connectedCallback() {
        if (!window.matchMedia('(hover: hover)').matches) return;

        this.radius = 0;
        this.target = 0;
        this.frame = null;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.onMove = this.onMove.bind(this);
        this.onLeave = this.onLeave.bind(this);
        this.addEventListener('pointermove', this.onMove);
        this.addEventListener('pointerleave', this.onLeave);
      }

      disconnectedCallback() {
        this.removeEventListener('pointermove', this.onMove);
        this.removeEventListener('pointerleave', this.onLeave);
        cancelAnimationFrame(this.frame);
      }

      onMove(event) {
        const rect = this.getBoundingClientRect();
        this.style.setProperty('--spot-x', `${event.clientX - rect.left}px`);
        this.style.setProperty('--spot-y', `${event.clientY - rect.top}px`);
        this.animateTo(Math.max(rect.width, rect.height) * 0.28);
      }

      onLeave() {
        this.animateTo(0);
      }

      animateTo(radius) {
        this.target = radius;
        if (this.reduceMotion) return this.setRadius(radius);
        if (!this.frame) this.frame = requestAnimationFrame(() => this.step());
      }

      step() {
        this.setRadius(this.radius + (this.target - this.radius) * 0.14);
        if (Math.abs(this.target - this.radius) < 0.5) {
          this.setRadius(this.target);
          this.frame = null;
          return;
        }
        this.frame = requestAnimationFrame(() => this.step());
      }

      setRadius(radius) {
        this.radius = radius;
        this.style.setProperty('--spot-r', `${radius}px`);
      }
    }
  );
}
